import React from "react"
import Navigation from "../../component/Navigation"
import withContainer from "../../commons/withContainer"

/**
 * Add Navigation to component's children.
 * This HoC is combined with #withContainer HoC.
 * @param Wrapped
 * @param size
 * @return {(function(*))|*}
 */
export default function withNavBreadcrumbs(Wrapped, size) {
  // eslint-disable-next-line react/display-name
  return withContainer((props) => {
    const { children } = props
    return (
      <Wrapped {...props}>
        <Navigation />
        {children}
      </Wrapped>
    )
  }, size)
}
